import ApiService from "@/core/services/api.service";

export default {
  select (query = {}) {
    return ApiService.query('contractor/vehicles', query)
  },
  create (data = {}) {
    return ApiService.post('contractor/vehicles', data)
  },
  update (id, data = {}) {
    return ApiService.patch(`contractor/vehicles/${id}`, data)
  },
  delete (id) {
    return ApiService.delete(`contractor/vehicles/${id}`)
  },
  switchAvailable (id) {
    return ApiService.post(`contractor/vehicles/${id}/switch_available`)
  }
}
